/** A ring needs at least three distinct vertices to enclose an area. */
export const MIN_RING_VERTICES = 3;

/** Name reported for thrown values that are not `Error`s. */
const UNKNOWN_ERROR_NAME = 'Error';

export function isPositiveNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

/** The error's name only: messages may carry data and must not be reported. */
export function errorNameOf(error: unknown): string {
  if (error instanceof Error) {
    return error.name;
  }
  return UNKNOWN_ERROR_NAME;
}
